$(document).ready(
    function () {

        let p = $("body").attr("p");
        let a = $("body").attr("a");
        if (p == 'organizer_event_subevent' && a == 'list') {

            $(document).on("click", ".event-subevent-refund-btn", function () {
                let event_id = $(this).attr("data-event-id");
                let event_subevent_id = $(this).attr("data-event-subevent-id");
                $('#modal-event-subevent-refund').modal('show');
                $('#modal-event-subevent-refund button#event-subevent-refund-modal-btn').val(null)
                $('#modal-event-subevent-refund button#event-subevent-refund-modal-btn').attr('data-event-id', event_id);
                $('#modal-event-subevent-refund button#event-subevent-refund-modal-btn').attr('data-event-subevent-id', event_subevent_id);
                if (!$('#modal-event-subevent-refund-feedback').hasClass('d-none')) {
                    $('#modal-event-subevent-refund-feedback').addClass('d-none');
                }
            });

            let event_subevent_refund_ajax_lock = false;

            $(document).on("click", "#event-subevent-refund-modal-btn", function () {

                let confirmMessage = $(this).attr("data-refund-confirm-message");
                if (!confirm(confirmMessage)) {
                    return false;
                }

                $(this).removeClass('btn-warning');
                $(this).addClass('btn-secondary');
                $(this).prop('disabled', true);
                $('#modal-event-subevent-refund input#refund_percent').prop('disabled', true);

                $("#modal-event-subevent-refund #number-of-refunded-orders span").html();
                $("#modal-event-subevent-refund #number-of-not-refunded-orders-pos span").html();
                $("#modal-event-subevent-refund #number-of-refunded-tickets span").html();
                $("#modal-event-subevent-refund #refund-event-error-list").empty();
                if (!$("#modal-event-subevent-refund #number-of-not-refunded-orders-pos").hasClass('d-none')) {
                    $("#modal-event-subevent-refund #number-of-not-refunded-orders-pos").addClass('d-none');
                }
                if (!$("#modal-event-subevent-refund #modal-event-subevent-refund #errors").hasClass('d-none')) {
                    $("#modal-event-subevent-refund #modal-event-subevent-refund #errors").addClass('d-none');
                }

                if ($('#modal-event-subevent-refund #modal-event-subevent-refund-feedback').hasClass('d-none')) {
                    $('#modal-event-subevent-refund #modal-event-subevent-refund-feedback').removeClass('d-none');
                }

                let event_id = $(this).attr("data-event-id");
                let event_subevent_id = $(this).attr("data-event-subevent-id");
                let refund_percent = $('#modal-event-subevent-refund input#refund_percent').val();
                let refund_message = $(this).attr("data-refund-message");

                if (!event_subevent_refund_ajax_lock) {

                    event_subevent_refund_ajax_lock = true;

                    $.ajax({
                        type: 'POST',
                        url: "/ajax/organizer_event_subevent/refund",
                        data: {
                            event_id: event_id,
                            event_subevent_id: event_subevent_id,
                            refund_percent: refund_percent
                        }
                    })
                        .done(function (data) {

                            if (data.number_of_refunded_orders !== undefined && data.number_of_refunded_orders !== null) {
                                $("#modal-event-subevent-refund #number-of-refunded-orders span").html(data.number_of_refunded_orders);
                            }

                            if (data.number_of_not_refunded_orders_pos !== undefined && data.number_of_not_refunded_orders_pos !== null && data.number_of_not_refunded_orders_pos > 0) {
                                $("#modal-event-subevent-refund #number-of-not-refunded-orders-pos").removeClass('d-none');
                                $("#modal-event-subevent-refund #number-of-not-refunded-orders-pos span").html(data.number_of_not_refunded_orders_pos);
                            }

                            if (data.number_of_refunded_tickets !== undefined && data.number_of_refunded_tickets !== null) {
                                $("#modal-event-subevent-refund #number-of-refunded-tickets span").html(data.number_of_refunded_tickets);
                            }

                            if (data.errors !== undefined && data.errors !== null) {
                                if (data.errors.length === 0) {
                                    $('#subevent-list ul[data-event-subevent-id=' + event_subevent_id + '] .event-subevent-refund-btn').remove();
                                    $('#subevent-list tr[data-event-subevent-id=' + event_subevent_id + '] .event-subevent-refund-btn').remove();
                                    $('#subevent-list ul[data-event-subevent-id=' + event_subevent_id + '] li.event-date').append(' <div class="refunded">' + refund_message + '</div>');
                                    $('#subevent-list tr[data-event-subevent-id=' + event_subevent_id + '] td.event-date').append(' <span class="refunded">' + refund_message + '</span>');

                                } else {

                                    let errors = data.errors;
                                    $("#modal-event-subevent-refund #errors").removeClass('d-none');
                                    errors.map(function (value) {
                                        $('#modal-event-subevent-refund #refund-event-subevent-error-list').append($('<tr>')
                                            .append($('<td>').append(value.name))
                                            .append($('<td>').append(value.order_id))
                                            .append($('<td>').append(value.transaction_id))
                                            .append($('<td>').append(value.error))
                                        );
                                    });

                                }
                            }

                        })
                        .fail(function (data) {

                            if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                                document.location.href = data.responseJSON.redirect_url;
                            }

                            event_subevent_refund_ajax_lock = false;

                        })
                        .always(function () {
                            event_subevent_refund_ajax_lock = false;
                        });

                }

                return false;

            });

        }

    }
);